<div class="flex flex-col">
    <div class="flex flex-row gap-x-2 items-start">
        <div class="basis-full">
            <div class="!hidden" appearance="outline" [formGroup]="group">
                <input type="hidden" [formControl]="group.get(field.name)" />
            </div>
            <mat-form-field class="form-full-width" appearance="outline" [formGroup]="mainForm">
                <fui-icon
                    matPrefix
                    [icon]="(isShowMunicipal$ | async) ? 'home-group' : 'city-variant-outline'"
                    [size]="1.25"
                    [fuiTooltip]="
                        (isShowMunicipal$ | async)
                            ? appService.language_dictionary.address_municipal_division
                            : appService.language_dictionary.address_administrative_division
                    "
                    class="mr-2"
                ></fui-icon>
                <mat-label>{{ field.label }}</mat-label>
                <input
                    matInput
                    [formControl]="mainForm.get(field.name)"
                    [matAutocomplete]="autoAddress"
                    [id]="field.id ? field.id : null"
                    [readonly]="!field.hideCoordinates && (field.disabled || data?.disabled)"
                    [required]="field.required"
                />
                <mat-hint
                    *ngIf="(field?.hint ?? '') !== ''"
                    [innerHtml]="field.hint"
                    class="truncate text-xxs"
                    [title]="field.hint"
                ></mat-hint>
                <mat-autocomplete
                    #autoAddress="matAutocomplete"
                    [displayWith]="getAddressPresentation"
                    (optionSelected)="changeAutoCompleteField($event.option.value)"
                >
                    <mat-option
                        *ngFor="let option of filteredOptionsSimple | async"
                        [ngClass]="allowSelection(option.fullname)"
                        [value]="mainForm.get(field.name).value ? option : null"
                    >
                        {{ option.fullname }}
                    </mat-option>
                </mat-autocomplete>
                <fui-button
                    *ngIf="!(field.disabled || data?.disabled) && !data?.disabled && group.get(field.name).value"
                    (clickEvent)="clearInput()"
                    matSuffix
                    [icon]="'close'"
                    [title]="appService.language_dictionary.system_clear"
                    [type]="'button-icon'"
                    [borderRadius]="'circle'"
                    [color]="'neutral'"
                    [height]="'mini'"
                    [iconSize]="16"
                    [disabled]="field.disabled"
                >
                </fui-button>
                <mat-progress-spinner
                    *ngIf="isLoadingSimple"
                    matSuffix
                    color="primary"
                    mode="indeterminate"
                    diameter="24"
                ></mat-progress-spinner>
                <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                    <mat-error
                        *ngIf="mainForm?.get(field.name)?.hasError(validation.name)"
                        [innerHTML]="
                            validation.name === 'serverError'
                                ? mainForm.get(field.name).errors?.serverError
                                : validation.message
                        "
                    >
                    </mat-error>
                </ng-container>
            </mat-form-field>
        </div>
        <div *ngIf="!field.hideCoordinates" class="flex">
            <div class="flex flex-row items-center gap-x-1 mt-2">
                <fui-button
                    (clickEvent)="setValueForm(); togglePanel()"
                    [disabled]="field.disabled || data?.disabled"
                    title="{{ appService.language_dictionary.system_edit }}"
                    icon="pencil-outline"
                    iconSize="20"
                    [color]="expansionPanel?.expanded ? 'soft' : 'flat'"
                    height="mini"
                    type="button-icon"
                    borderRadius="circle"
                >
                </fui-button>

                <ng-container *ngIf="!data.hideMarker">
                    <fui-button
                        (clickEvent)="editCoordinates()"
                        [disabled]="isMarkerDisabled | async"
                        [color]="markerColor | async"
                        title="{{ appService.language_dictionary.system_bind_coordinates_by_address }}"
                        icon="map-marker"
                        height="mini"
                        type="button-icon"
                        borderRadius="circle"
                    >
                    </fui-button>
                </ng-container>

                <fui-button
                    (clickEvent)="editAddressByCoordinates()"
                    [disabled]="field?.disabled || data?.disabled"
                    icon="map"
                    title="{{ appService.language_dictionary.system_geocode_get_address }}"
                    color="flat"
                    height="mini"
                    type="button-icon"
                    borderRadius="circle"
                >
                </fui-button>

                <ng-container *ngIf="data?.findAddressField">
                    <fui-button
                        (clickEvent)="editAddressByFindAddress()"
                        [disabled]="field?.disabled || data?.disabled"
                        icon="map-marker-distance"
                        title="{{ appService.language_dictionary.system_geocode_find_address }}"
                        color="flat"
                        height="mini"
                        type="button-icon"
                        borderRadius="circle"
                    >
                    </fui-button>
                </ng-container>
            </div>
        </div>
    </div>

    <div
        fxLayout="row wrap"
        class="address-form-panel"
        fxLayoutAlign="flex-start"
        *ngIf="!field.disabled && !data?.disabled"
    >
        <div fxFlex="0 1 100%" [ngClass]="{ 'form-field-margin-bottom': expansionPanel.expanded }">
            <mat-expansion-panel
                #expansionPanel
                [expanded]="false"
                disabled
                hideToggle
                [ngClass]="{ 'hide-border': !expansionPanel.expanded }"
            >
                <mat-expansion-panel-header
                    [ngClass]="{
                        '!hidden': !expansionPanel.expanded,
                    }"
                >
                    <mat-panel-title>
                        {{ appService.language_dictionary.address_dialog_title }}
                    </mat-panel-title>
                    <div class="flex flex-row gap-x-1">
                        <fui-button
                            (clickEvent)="changedDivision(EDivisions.administrative)"
                            title="{{ appService.language_dictionary?.address_administrative_division }}"
                            icon="city-variant-outline"
                            type="button-icon"
                            borderRadius="circle"
                            height="slim"
                            color="{{ (isShowMunicipal$ | async) === false ? 'soft' : 'flat' }}"
                        >
                        </fui-button>
                        <fui-button
                            (clickEvent)="changedDivision(EDivisions.municipal)"
                            title="{{ appService.language_dictionary?.address_municipal_division }}"
                            icon="home-group"
                            type="button-icon"
                            borderRadius="circle"
                            height="slim"
                            color="{{ (isShowMunicipal$ | async) ? 'soft' : 'flat' }}"
                        >
                        </fui-button>
                        <fui-button
                            *ngIf="!!data.factorId"
                            (clickEvent)="openFactorSettings()"
                            title="{{ appService.language_dictionary.go_to_the_constructor }}"
                            icon="wrench-cog-outline"
                            type="button-icon"
                            borderRadius="circle"
                            height="slim"
                            color="flat"
                        >
                        </fui-button>
                    </div>
                    <fui-button
                        class="ml-[8px]"
                        (clickEvent)="close()"
                        title="{{ appService.language_dictionary?.system_close }}"
                        icon="close"
                        type="button-icon"
                        height="slim"
                        color="flat"
                    >
                    </fui-button>
                </mat-expansion-panel-header>
                <div class="mt-[8px]">
                    <ng-container [ngTemplateOutlet]="formAddress" *ngIf="expansionPanel.expanded"> </ng-container>
                </div>
            </mat-expansion-panel>
        </div>
    </div>
    <ng-template #formAddress>
        <div #formRef class="address-dialog-container" [formGroup]="form" (keydown.enter)="$event.preventDefault()">
            <div class="flex flex-col">
                <div class="flex flex-row gap-x-2">
                    <!-- Контрол Код ОКСМ -->
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                inputType: 'text',
                                label: appService.language_dictionary.address_code_oksm,
                                name: 'code_oksm',
                                disabled: true,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form"
                        ></ng-container>
                    </div>
                    <!-- Контрол Страна -->
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                inputType: 'text',
                                label: appService.language_dictionary.address_code_country_name,
                                name: 'country',
                                disabled: true,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form"
                        ></ng-container>
                    </div>
                    <!-- Контрол Индекс -->
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                inputType: 'text',
                                label: appService.language_dictionary.address_index,
                                name: 'postalcode',
                                disabled: false,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form"
                        ></ng-container>
                    </div>
                </div>
                <div class="flex flex-row gap-x-2">
                    <!-- Контрол субъекта-->
                    <div class="basis-full">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{ appService.language_dictionary.address_subject }}</mat-label>
                            <input
                                matInput
                                formControlName="subject"
                                [matAutocomplete]="autoAddressSubject"
                                (ngModelChange)="
                                    clearField('subject', 'administrative_region');
                                    clearField('subject', 'municipal_region')
                                "
                            />

                            <mat-autocomplete
                                #autoAddressSubject="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="setPostalCode('postalcode'); setValueChildren('subject')"
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['subject'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.subject"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="form.controls['subject'].setValue(null); clearFieldsByLvl(1)"
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.subject"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Контрол Административного района -->
                    <div class="basis-full" *ngIf="(isShowMunicipal$ | async) === false">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{
                                appService.language_dictionary.address_administrative_region_name
                            }}</mat-label>
                            <input
                                matInput
                                formControlName="administrative_region"
                                [matAutocomplete]="autoAddressAdministrativeRegion"
                                (ngModelChange)="clearField('administrative_region', 'city')"
                            />
                            <mat-autocomplete
                                #autoAddressAdministrativeRegion="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="
                                    setValueChildren('administrative_region'); setPostalCode('administrative_region')
                                "
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['administrative_region'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.administrative_region"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="form.controls['administrative_region'].setValue(null); clearFieldsByLvl(2)"
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.administrative_region"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Контрол Муниципального района -->
                    <div class="basis-full" *ngIf="isShowMunicipal$ | async">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{ appService.language_dictionary.address_municipal_region_name }}</mat-label>
                            <input
                                matInput
                                formControlName="municipal_region"
                                [matAutocomplete]="autoAddressMunicipalRegion"
                                (ngModelChange)="clearField('municipal_region', 'urban_settlement')"
                            />
                            <mat-autocomplete
                                #autoAddressMunicipalRegion="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="
                                    setValueChildren('municipal_region'); setPostalCode('municipal_region')
                                "
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['municipal_region'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.municipal_region"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="
                                    form.controls['municipal_region'].setValue(null); clearFieldsByLvl(5, [0, 2, 4])
                                "
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.municipal_region"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="flex flex-row gap-x-2">
                    <!-- Контрол Сельское/городское поселение -->
                    <div class="basis-full" *ngIf="isShowMunicipal$ | async">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{ appService.language_dictionary.address_urban_settlement_name }}</mat-label>
                            <input
                                matInput
                                formControlName="urban_settlement"
                                [matAutocomplete]="autoAddressUrbanSettlement"
                                (ngModelChange)="clearField('urban_settlement', 'city')"
                            />
                            <mat-autocomplete
                                #autoAddressUrbanSettlement="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="
                                    setValueChildren('urban_settlement'); setPostalCode('urban_settlement')
                                "
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['urban_settlement'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.urban_settlement"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="form.controls['urban_settlement'].setValue(null); clearFieldsByLvl(6)"
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.urban_settlement"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Контрол Города -->
                    <div class="basis-full">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{ appService.language_dictionary.address_city_name }}</mat-label>
                            <input
                                matInput
                                formControlName="city"
                                [matAutocomplete]="autoAddressCity"
                                (ngModelChange)="clearField('city', 'locality')"
                            />
                            <mat-autocomplete
                                #autoAddressCity="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="setValueChildren('city'); setPostalCode('city')"
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['city'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.city"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="form.controls['city'].setValue(null); clearFieldsByLvl(6)"
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.city"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Контрол Населенного пункта -->
                    <div class="basis-full">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{ appService.language_dictionary.address_locality_name }}</mat-label>
                            <input
                                matInput
                                formControlName="locality"
                                [matAutocomplete]="autoAddressLocality"
                                (ngModelChange)="clearField('locality', 'street')"
                            />
                            <mat-autocomplete
                                #autoAddressLocality="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="setValueChildren('locality'); setPostalCode('locality')"
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['locality'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.locality"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="form.controls['locality'].setValue(null); clearFieldsByLvl(6)"
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.locality"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="flex flex-row gap-x-2">
                    <!-- Контрол Элемента планировочной структуры -->
                    <div class="basis-full">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{ appService.language_dictionary.address_street_name }}</mat-label>
                            <input
                                matInput
                                formControlName="street"
                                [matAutocomplete]="autoAddressStreet"
                                (ngModelChange)="clearField('street', 'el_road_network')"
                            />
                            <mat-autocomplete
                                #autoAddressStreet="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="setValueChildren('street'); setPostalCode('street')"
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['street'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.street"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="
                                    form.controls['street'].setValue(null); clearFieldsByLvl(-1, [8, 9, 10, 11, 12, 13])
                                "
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.street"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Контрол улично-дорожной сети -->
                    <div class="basis-full">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{ appService.language_dictionary.address_el_road_network }}</mat-label>
                            <input
                                matInput
                                formControlName="el_road_network"
                                [matAutocomplete]="autoAddressElRoadNetwork"
                                (ngModelChange)="clearField('el_road_network', 'land_plot')"
                            />
                            <mat-autocomplete
                                #autoAddressElRoadNetwork="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="setValueChildren('el_road_network'); setPostalCode('el_road_network')"
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['el_road_network'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.el_road_network"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="
                                    form.controls['el_road_network'].setValue(null);
                                    clearFieldsByLvl(-1, [9, 10, 11, 12, 13])
                                "
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.el_road_network"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="basis-full">
                        <div class="flex flex-row gap-x-2">
                            <!-- Контрол Земельного участка -->
                            <div class="basis-full">
                                <mat-form-field class="form-full-width" appearance="outline">
                                    <mat-label>{{ appService.language_dictionary.address_land_plot_name }}</mat-label>
                                    <input
                                        matInput
                                        formControlName="land_plot"
                                        [matAutocomplete]="autoAddressLandPlot"
                                        (ngModelChange)="clearField('land_plot', 'house')"
                                    />
                                    <mat-autocomplete
                                        #autoAddressLandPlot="matAutocomplete"
                                        [displayWith]="displayFn"
                                        (optionSelected)="setValueChildren('land_plot'); setPostalCode('land_plot')"
                                    >
                                        <mat-option
                                            *ngFor="let option of filteredAddressOptions['land_plot'] | async"
                                            [ngClass]="allowSelection(option.fullname)"
                                            [value]="option"
                                        >
                                            {{ option.fullname }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <button
                                        mat-button
                                        *ngIf="form.value.land_plot"
                                        matSuffix
                                        mat-icon-button
                                        tabindex="-1"
                                        title="{{ appService.language_dictionary.system_clear }}"
                                        (click)="
                                            form.controls['land_plot'].setValue(null);
                                            clearFieldsByLvl(-1, [10, 11, 12, 13])
                                        "
                                    >
                                        <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                                    </button>
                                    <mat-progress-spinner
                                        *ngIf="isLoading.land_plot"
                                        matSuffix
                                        color="primary"
                                        mode="indeterminate"
                                        diameter="35"
                                    ></mat-progress-spinner>
                                    <mat-error>
                                        {{ appService.language_dictionary.address_dialog_region_error }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <!-- Контрол Здания -->
                            <div class="basis-full">
                                <mat-form-field class="form-full-width" appearance="outline">
                                    <mat-label>{{ appService.language_dictionary.address_house_name }}</mat-label>
                                    <input
                                        matInput
                                        formControlName="house"
                                        [matAutocomplete]="autoAddressHouse"
                                        (ngModelChange)="clearField('house', 'apartment')"
                                    />
                                    <mat-autocomplete
                                        #autoAddressHouse="matAutocomplete"
                                        [displayWith]="displayFn"
                                        (optionSelected)="setValueChildren('house'); setPostalCode('house')"
                                    >
                                        <mat-option
                                            *ngFor="let option of filteredAddressOptions['house'] | async"
                                            [ngClass]="allowSelection(option.fullname)"
                                            [value]="option"
                                        >
                                            {{ option.fullname }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <button
                                        mat-button
                                        *ngIf="form.value.house"
                                        matSuffix
                                        mat-icon-button
                                        tabindex="-1"
                                        title="{{ appService.language_dictionary.system_clear }}"
                                        (click)="
                                            form.controls['house'].setValue(null); clearFieldsByLvl(-1, [11, 12, 13])
                                        "
                                    >
                                        <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                                    </button>
                                    <mat-progress-spinner
                                        *ngIf="isLoading.house"
                                        matSuffix
                                        color="primary"
                                        mode="indeterminate"
                                        diameter="35"
                                    ></mat-progress-spinner>
                                    <mat-error>
                                        {{ appService.language_dictionary.address_dialog_region_error }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row gap-x-2">
                    <div class="basis-full">
                        <div class="flex flex-row gap-x-2">
                            <!-- Контрол Помещения -->
                            <div class="basis-full">
                                <mat-form-field class="form-full-width" appearance="outline">
                                    <mat-label>{{ appService.language_dictionary.address_apartment_name }}</mat-label>
                                    <input
                                        matInput
                                        formControlName="apartment"
                                        [matAutocomplete]="autoAddressApartment"
                                        (ngModelChange)="clearField('apartment', 'room')"
                                    />
                                    <mat-autocomplete
                                        #autoAddressApartment="matAutocomplete"
                                        [displayWith]="displayFn"
                                        (optionSelected)="setValueChildren('apartment'); setPostalCode('apartment')"
                                    >
                                        <mat-option
                                            *ngFor="let option of filteredAddressOptions['apartment'] | async"
                                            [ngClass]="allowSelection(option.fullname)"
                                            [value]="option"
                                        >
                                            {{ option.fullname }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <button
                                        mat-button
                                        *ngIf="form.value.apartment"
                                        matSuffix
                                        mat-icon-button
                                        tabindex="-1"
                                        title="{{ appService.language_dictionary.system_clear }}"
                                        (click)="form.controls['apartment'].setValue(null); clearFieldsByLvl(-1, [12])"
                                    >
                                        <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                                    </button>
                                    <mat-progress-spinner
                                        *ngIf="isLoading.apartment"
                                        matSuffix
                                        color="primary"
                                        mode="indeterminate"
                                        diameter="35"
                                    ></mat-progress-spinner>
                                    <mat-error>
                                        {{ appService.language_dictionary.address_dialog_region_error }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <!-- Контрол Помещения в пределах помещения -->
                            <div class="basis-full">
                                <mat-form-field class="form-full-width" appearance="outline">
                                    <mat-label>{{ appService.language_dictionary.address_room_name }}</mat-label>
                                    <input matInput formControlName="room" [matAutocomplete]="autoAddressRoom" />
                                    <mat-autocomplete
                                        #autoAddressRoom="matAutocomplete"
                                        [displayWith]="displayFn"
                                        (optionSelected)="setValueChildren('room'); setPostalCode('room')"
                                    >
                                        <mat-option
                                            *ngFor="let option of filteredAddressOptions['room'] | async"
                                            [ngClass]="allowSelection(option.fullname)"
                                            [value]="option"
                                        >
                                            {{ option.fullname }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <button
                                        mat-button
                                        *ngIf="form.value.room"
                                        matSuffix
                                        mat-icon-button
                                        tabindex="-1"
                                        title="{{ appService.language_dictionary.system_clear }}"
                                        (click)="form.controls['room'].setValue(null)"
                                    >
                                        <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                                    </button>
                                    <mat-progress-spinner
                                        *ngIf="isLoading.room"
                                        matSuffix
                                        color="primary"
                                        mode="indeterminate"
                                        diameter="35"
                                    ></mat-progress-spinner>
                                    <mat-error>
                                        {{ appService.language_dictionary.address_dialog_region_error }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <!-- Контрол Парковочного места -->
                    <div class="basis-full">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{ appService.language_dictionary.address_parking_space_name }}</mat-label>
                            <input
                                matInput
                                formControlName="parking_space"
                                [matAutocomplete]="autoAddressParkingSpace"
                            />

                            <mat-autocomplete
                                #autoAddressParkingSpace="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="setValueChildren('parking_space'); setPostalCode('parking_space')"
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['parking_space'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.parking_space"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="form.controls['parking_space'].setValue(null)"
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.parking_space"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Контрол Автономного округа -->
                    <div class="basis-full">
                        <mat-form-field class="form-full-width" appearance="outline">
                            <mat-label>{{
                                appService.language_dictionary.address_lvl_autonomous_okrug_name
                            }}</mat-label>
                            <input
                                matInput
                                formControlName="lvl_autonomous_okrug"
                                [matAutocomplete]="autoAddressLvlAutonomousOkrug"
                            />

                            <mat-autocomplete
                                #autoAddressLvlAutonomousOkrug="matAutocomplete"
                                [displayWith]="displayFn"
                            >
                                <mat-option
                                    *ngFor="let option of filteredAddressOptions['lvl_autonomous_okrug'] | async"
                                    [ngClass]="allowSelection(option.fullname)"
                                    [value]="option"
                                >
                                    {{ option.fullname }}
                                </mat-option>
                            </mat-autocomplete>
                            <button
                                mat-button
                                *ngIf="form.value.lvl_autonomous_okrug"
                                matSuffix
                                mat-icon-button
                                tabindex="-1"
                                title="{{ appService.language_dictionary.system_clear }}"
                                (click)="form.controls['lvl_autonomous_okrug'].setValue(null)"
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                            </button>
                            <mat-progress-spinner
                                *ngIf="isLoading.lvl_autonomous_okrug"
                                matSuffix
                                color="primary"
                                mode="indeterminate"
                                diameter="35"
                            ></mat-progress-spinner>
                            <mat-error>
                                {{ appService.language_dictionary.address_dialog_region_error }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="flex flex-row gap-x-2">
                <!-- Контрол  внутригородской территории -->
                <div class="basis-full">
                    <mat-form-field class="form-full-width" appearance="outline">
                        <mat-label>{{
                            appService.language_dictionary.address_lvl_inner_city_territory_name
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="lvl_inner_city_territory"
                            [matAutocomplete]="autoAddressLvlInnerCityTerritory"
                        />
                        <mat-autocomplete
                            #autoAddressLvlInnerCityTerritory="matAutocomplete"
                            [displayWith]="displayFn"
                            (optionSelected)="
                                setValueChildren('lvl_inner_city_territory'); setPostalCode('lvl_inner_city_territory')
                            "
                        >
                            <mat-option
                                *ngFor="let option of filteredAddressOptions['lvl_inner_city_territory'] | async"
                                [ngClass]="allowSelection(option.fullname)"
                                [value]="option"
                            >
                                {{ option.fullname }}
                            </mat-option>
                        </mat-autocomplete>
                        <button
                            mat-button
                            *ngIf="form.value.lvl_inner_city_territory"
                            matSuffix
                            mat-icon-button
                            tabindex="-1"
                            title="{{ appService.language_dictionary.system_clear }}"
                            (click)="form.controls['lvl_inner_city_territory'].setValue(null)"
                        >
                            <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                        </button>
                        <mat-progress-spinner
                            *ngIf="isLoading.lvl_inner_city_territory"
                            matSuffix
                            color="primary"
                            mode="indeterminate"
                            diameter="35"
                        ></mat-progress-spinner>
                        <mat-error>
                            {{ appService.language_dictionary.address_dialog_region_error }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <!-- Контрол  дополнительных территорий -->
                <div class="basis-full">
                    <mat-form-field class="form-full-width" appearance="outline">
                        <mat-label>{{
                            appService.language_dictionary.address_lvl_additional_territories_name
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="lvl_additional_territories"
                            [matAutocomplete]="autoAddressLvlAdditionalTerritories"
                        />
                        <mat-autocomplete
                            #autoAddressLvlAdditionalTerritories="matAutocomplete"
                            [displayWith]="displayFn"
                            (optionSelected)="
                                setValueChildren('lvl_additional_territories');
                                setPostalCode('lvl_additional_territories')
                            "
                        >
                            <mat-option
                                *ngFor="let option of filteredAddressOptions['lvl_additional_territories'] | async"
                                [ngClass]="allowSelection(option.fullname)"
                                [value]="option"
                            >
                                {{ option.fullname }}
                            </mat-option>
                        </mat-autocomplete>
                        <button
                            mat-button
                            *ngIf="form.value.lvl_additional_territories"
                            matSuffix
                            mat-icon-button
                            tabindex="-1"
                            title="{{ appService.language_dictionary.system_clear }}"
                            (click)="
                                form.controls['lvl_additional_territories'].setValue(null);
                                clearField('lvl_autonomous_okrug', 'room')
                            "
                        >
                            <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                        </button>
                        <mat-progress-spinner
                            *ngIf="isLoading.lvl_additional_territories"
                            matSuffix
                            color="primary"
                            mode="indeterminate"
                            diameter="35"
                        ></mat-progress-spinner>
                        <mat-error>
                            {{ appService.language_dictionary.address_dialog_region_error }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <!-- Контрол  -->
                <div class="basis-full">
                    <mat-form-field class="form-full-width" appearance="outline">
                        <mat-label>{{
                            appService.language_dictionary.address_lvl_objects_add_territories_name
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="lvl_objects_add_territories"
                            [matAutocomplete]="autoAddressLvlObjectsAddTerritoriesName"
                        />
                        <mat-autocomplete
                            #autoAddressLvlObjectsAddTerritoriesName="matAutocomplete"
                            [displayWith]="displayFn"
                            (optionSelected)="
                                setValueChildren('lvl_objects_add_territories');
                                setPostalCode('lvl_objects_add_territories')
                            "
                        >
                            <mat-option
                                *ngFor="let option of filteredAddressOptions['lvl_objects_add_territories'] | async"
                                [ngClass]="allowSelection(option.fullname)"
                                [value]="option"
                            >
                                {{ option.fullname }}
                            </mat-option>
                        </mat-autocomplete>
                        <button
                            mat-button
                            *ngIf="form.value.lvl_objects_add_territories"
                            matSuffix
                            mat-icon-button
                            tabindex="-1"
                            title="{{ appService.language_dictionary.system_clear }}"
                            (click)="form.controls['lvl_objects_add_territories'].setValue(null)"
                        >
                            <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                        </button>
                        <mat-progress-spinner
                            *ngIf="isLoading.lvl_objects_add_territories"
                            matSuffix
                            color="primary"
                            mode="indeterminate"
                            diameter="35"
                        ></mat-progress-spinner>
                        <mat-error>
                            {{ appService.language_dictionary.address_dialog_region_error }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <mat-form-field class="form-full-width" appearance="outline">
                <mat-label>{{ appService.language_dictionary.address_dialog_add_info }}</mat-label>
                <textarea rows="3" matInput formControlName="additional_information"></textarea>
                <button
                    mat-button
                    *ngIf="form.value.additional_information"
                    matSuffix
                    mat-icon-button
                    tabindex="-1"
                    title="{{ appService.language_dictionary.system_clear }}"
                    (click)="form.controls['additional_information'].setValue(null)"
                >
                    <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
                </button>
                <mat-error>
                    {{ appService.language_dictionary.address_dialog_add_info_error }}
                </mat-error>
            </mat-form-field>
            <div class="flex gap-2">
                <fui-button
                    (clickEvent)="save()"
                    [icon]="'checkbox-marked-circle-outline'"
                    [label]="appService.language_dictionary.system_save"
                    color="gray"
                    height="slim"
                >
                </fui-button>
                <fui-button
                    (clickEvent)="clearForm()"
                    [icon]="'eraser'"
                    [label]="appService.language_dictionary.system_clear"
                    color="gray"
                    height="slim"
                >
                </fui-button>
            </div>
        </div>
    </ng-template>
</div>
